var _g, _path, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJoiningTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 341,
    height: 215,
    viewBox: "0 0 341 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1160_43934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 63.1017C2 55.4179 6.35577 48.4433 13.3847 45.3392C41.3036 33.0099 114.87 3 169.5 3C224.13 3 297.696 33.0099 325.615 45.3392C332.644 48.4433 337 55.4179 337 63.1017V146.534C337 154.405 332.434 161.515 325.173 164.555C295.88 176.817 218.772 207 169.5 207C120.228 207 43.1198 176.817 13.827 164.555C6.56626 161.515 2 154.405 2 146.534V63.1017Z",
    fill: "#2A1771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 63.1017C2 55.4179 6.35577 48.4433 13.3847 45.3392C41.3036 33.0099 114.87 3 169.5 3C224.13 3 297.696 33.0099 325.615 45.3392C332.644 48.4433 337 55.4179 337 63.1017V146.534C337 154.405 332.434 161.515 325.173 164.555C295.88 176.817 218.772 207 169.5 207C120.228 207 43.1198 176.817 13.827 164.555C6.56626 161.515 2 154.405 2 146.534V63.1017Z",
    fill: "url(#paint0_radial_1160_43934)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 63.1017C10 58.448 12.6104 54.4265 16.6165 52.6574C30.4223 46.5606 55.5004 36.1 83.8292 27.1765C112.293 18.2106 143.415 11 169.5 11C195.585 11 226.707 18.2106 255.171 27.1765C283.5 36.1 308.578 46.5606 322.384 52.6574C326.39 54.4265 329 58.448 329 63.1017V146.534C329 151.299 326.262 155.426 322.084 157.175C307.559 163.255 281.213 173.763 252.446 182.739C223.484 191.775 192.858 199 169.5 199C146.142 199 115.516 191.775 86.554 182.739C57.7872 173.763 31.4407 163.255 16.9161 157.175C12.7377 155.426 10 151.299 10 146.534V63.1017Z",
    stroke: "url(#paint1_linear_1160_43934)",
    strokeWidth: 16
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_1160_43934)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 147,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 147,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint2_radial_1160_43934)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_1160_43934)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 161,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 161,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint3_radial_1160_43934)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dd_1160_43934)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 176,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 176,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint4_radial_1160_43934)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dd_1160_43934)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 187,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 187,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint5_radial_1160_43934)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_dd_1160_43934)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 194,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 194,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint6_radial_1160_43934)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_dd_1160_43934)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 187,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 187,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint7_radial_1160_43934)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_dd_1160_43934)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 176,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 176,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint8_radial_1160_43934)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_dd_1160_43934)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 161,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 161,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint9_radial_1160_43934)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_dd_1160_43934)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 321,
    y: 147,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321,
    y: 147,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint10_radial_1160_43934)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_dd_1160_43934)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 116,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 116,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint11_radial_1160_43934)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_dd_1160_43934)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 82,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 82,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint12_radial_1160_43934)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_dd_1160_43934)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 116,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 116,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint13_radial_1160_43934)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_dd_1160_43934)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 82,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 82,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint14_radial_1160_43934)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_dd_1160_43934)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 51,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 51,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint15_radial_1160_43934)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_dd_1160_43934)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 37,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 37,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint16_radial_1160_43934)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_dd_1160_43934)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 22,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 22,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint17_radial_1160_43934)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_dd_1160_43934)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 11,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 11,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint18_radial_1160_43934)"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_dd_1160_43934)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 5,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 5,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint19_radial_1160_43934)"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_dd_1160_43934)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 11,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 11,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint20_radial_1160_43934)"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_dd_1160_43934)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 22,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 22,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint21_radial_1160_43934)"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_dd_1160_43934)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 37,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 37,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint22_radial_1160_43934)"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_dd_1160_43934)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 321,
    y: 51,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321,
    y: 51,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint23_radial_1160_43934)"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_d_1160_43934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.8516 63.4922L96.9844 86.6719L100.617 66.3047L109.078 66.2109L111.492 86.5078L113.578 64.3125L120.609 65.2266C118.922 75.4453 117.328 85.7734 115.828 96.2109L107.297 96.6562L104.508 74.1797L100.195 97.1016L92.1797 96.7734C90.9766 86.1484 89.5234 75.2031 87.8203 63.9375L94.8516 63.4922ZM130.172 73.0781C135.312 73.3594 137.883 75.9453 137.883 80.8359V97.4766L132.422 97.5703L132.234 95.3438C131.109 96.625 129.617 97.2656 127.758 97.2656C126.961 97.2656 126.102 97.1406 125.18 96.8906C122.414 96.2031 121.031 94.0625 121.031 90.4688C121.031 90.0312 121.055 89.5625 121.102 89.0625C121.414 85.3594 124.047 83.5078 129 83.5078C129.953 83.5078 131 83.5781 132.141 83.7188V81C132.141 78.7969 131.445 77.6953 130.055 77.6953H129.961C129.852 77.6797 129.75 77.6719 129.656 77.6719C128.141 77.6719 127.383 78.9062 127.383 81.375V81.7266L121.805 81.2578C121.805 75.8047 124.43 73.0781 129.68 73.0781H130.172ZM132.141 91.5938V87.4688C131.469 87.3281 130.859 87.2578 130.312 87.2578C128.891 87.2578 127.922 87.7344 127.406 88.6875C127.094 89.2656 126.938 89.8047 126.938 90.3047C126.938 90.9297 127.188 91.4844 127.688 91.9688C128.078 92.3438 128.586 92.5312 129.211 92.5312C130.008 92.5312 130.984 92.2188 132.141 91.5938ZM146.32 68.3672C146.32 69.3203 145.984 70.1328 145.312 70.8047C144.641 71.4766 143.828 71.8125 142.875 71.8125C141.938 71.8125 141.133 71.4766 140.461 70.8047C139.789 70.1328 139.453 69.3203 139.453 68.3672C139.453 67.4297 139.789 66.625 140.461 65.9531C141.133 65.2812 141.938 64.9453 142.875 64.9453C143.828 64.9453 144.641 65.2812 145.312 65.9531C145.984 66.625 146.32 67.4297 146.32 68.3672ZM140.039 97.9453C139.93 88.8047 139.875 80.9062 139.875 74.25L145.781 73.8984C145.594 80.2734 145.5 86.6094 145.5 92.9062C145.5 94.5938 145.508 96.2734 145.523 97.9453H140.039ZM151.547 66.2812L156.867 65.9297V73.6875L161.344 73.5703L161.414 78L156.867 78.2109V88.875C156.867 91.3594 157.922 92.6016 160.031 92.6016C160.469 92.6016 160.945 92.5469 161.461 92.4375L161.25 97.5938C160.5 97.6875 159.789 97.7344 159.117 97.7344C154.18 97.7344 151.664 95.1875 151.57 90.0938V78.6328L147.727 78.8672L147.633 73.6406L151.57 73.6875L151.547 66.2812ZM169.945 68.3672C169.945 69.3203 169.609 70.1328 168.938 70.8047C168.266 71.4766 167.453 71.8125 166.5 71.8125C165.562 71.8125 164.758 71.4766 164.086 70.8047C163.414 70.1328 163.078 69.3203 163.078 68.3672C163.078 67.4297 163.414 66.625 164.086 65.9531C164.758 65.2812 165.562 64.9453 166.5 64.9453C167.453 64.9453 168.266 65.2812 168.938 65.9531C169.609 66.625 169.945 67.4297 169.945 68.3672ZM163.664 97.9453C163.555 88.8047 163.5 80.9062 163.5 74.25L169.406 73.8984C169.219 80.2734 169.125 86.6094 169.125 92.9062C169.125 94.5938 169.133 96.2734 169.148 97.9453H163.664ZM175.57 73.1484L175.805 76.9688C176.461 74.9375 178.188 73.9062 180.984 73.875H181.078C183.828 73.875 185.703 74.9531 186.703 77.1094C187.391 78.5781 187.734 82.0156 187.734 87.4219C187.734 90.0781 187.648 93.2188 187.477 96.8438H181.805C182.008 92.0156 182.109 88.2734 182.109 85.6172C182.109 84.2891 182.086 83.2266 182.039 82.4297C181.883 80.0859 181.133 78.9141 179.789 78.9141C178.445 78.9141 177.602 79.5391 177.258 80.7891L177.492 97.7812L171.984 97.8281C171.984 90.6406 171.742 82.5703 171.258 73.6172L175.57 73.1484ZM201.539 91.2656V81.75C200.773 80.2031 199.805 79.4297 198.633 79.4297C198.398 79.4297 198.156 79.4609 197.906 79.5234C196.391 79.8828 195.555 81.9688 195.398 85.7812C195.383 86.1875 195.375 86.5781 195.375 86.9531C195.375 90.0625 195.953 91.9688 197.109 92.6719C197.5 92.9219 197.914 93.0469 198.352 93.0469C199.32 93.0469 200.383 92.4531 201.539 91.2656ZM190.336 100.547L195.844 100.242C195.828 100.43 195.82 100.617 195.82 100.805C195.82 102.508 196.5 103.438 197.859 103.594C198.078 103.625 198.281 103.641 198.469 103.641C199.641 103.641 200.477 103.172 200.977 102.234C201.414 101.391 201.633 99.8125 201.633 97.5C201.633 96.875 201.617 96.1875 201.586 95.4375C200.711 97.1875 199.086 98.1406 196.711 98.2969C192.07 98.25 189.75 94.3047 189.75 86.4609V86.2969C189.781 78.3594 192.539 74.3672 198.023 74.3203C199.523 74.3203 200.867 75.1953 202.055 76.9453L202.125 73.2188L207.258 73.4531C207.258 86.3438 207.219 94.3281 207.141 97.4062C207.062 100.484 206.594 102.953 205.734 104.812C204.891 106.672 203.445 107.859 201.398 108.375C200.32 108.656 199.25 108.797 198.188 108.797C197.234 108.797 196.289 108.688 195.352 108.469C193.352 108 191.977 107.117 191.227 105.82C190.602 104.758 190.289 103.367 190.289 101.648C190.289 101.305 190.305 100.938 190.336 100.547ZM221.766 66.2812L227.086 65.9297V73.6875L231.562 73.5703L231.633 78L227.086 78.2109V88.875C227.086 91.3594 228.141 92.6016 230.25 92.6016C230.688 92.6016 231.164 92.5469 231.68 92.4375L231.469 97.5938C230.719 97.6875 230.008 97.7344 229.336 97.7344C224.398 97.7344 221.883 95.1875 221.789 90.0938V78.6328L217.945 78.8672L217.852 73.6406L221.789 73.6875L221.766 66.2812ZM241.852 73.7578C247.164 73.7578 249.82 77.4453 249.82 84.8203C249.82 85.1172 249.812 85.4141 249.797 85.7109C249.578 93.6953 246.75 97.7266 241.312 97.8047C241.25 97.8203 241.188 97.8281 241.125 97.8281C235.953 97.8281 233.367 94.0547 233.367 86.5078V85.8516C233.523 77.7891 236.352 73.7578 241.852 73.7578ZM241.078 79.1016C240.094 79.4453 239.422 80.7188 239.062 82.9219C238.844 84.2344 238.734 85.5547 238.734 86.8828C238.734 87.7734 238.781 88.6719 238.875 89.5781C239.125 91.8281 239.93 92.9922 241.289 93.0703H241.453C242.719 93.0703 243.586 92.2344 244.055 90.5625C244.445 89.1719 244.641 87.5234 244.641 85.6172C244.641 85.1484 244.633 84.6719 244.617 84.1875C244.492 81.6719 244.117 80.1016 243.492 79.4766C243.102 79.1016 242.633 78.9141 242.086 78.9141C241.773 78.9141 241.438 78.9766 241.078 79.1016ZM126.07 132.727L133.031 132.258C132.938 133.227 132.891 134.102 132.891 134.883C132.891 138.43 133.773 140.203 135.539 140.203H135.633C137.773 140.141 138.844 139 138.844 136.781V136.57C138.766 134.211 136.742 131.898 132.773 129.633C128.914 127.445 126.984 123.836 126.984 118.805C126.984 118.648 126.992 118.492 127.008 118.336C127.117 113.07 130.07 110.391 135.867 110.297H136.055C141.289 110.297 143.906 113.633 143.906 120.305C143.906 120.836 143.891 121.398 143.859 121.992L137.742 122.344C137.805 121.641 137.836 120.992 137.836 120.398C137.836 117.602 137.156 116.203 135.797 116.203C134.156 116.203 133.258 117.039 133.102 118.711C133.086 118.945 133.078 119.18 133.078 119.414C133.078 120.805 133.492 122.102 134.32 123.305C135.273 124.695 136.906 125.969 139.219 127.125C141.547 128.281 143.172 129.867 144.094 131.883C144.75 133.336 145.078 134.883 145.078 136.523C145.078 137.148 145.031 137.789 144.938 138.445C144.578 140.805 143.578 142.766 141.938 144.328C140.297 145.875 138.094 146.719 135.328 146.859C135.141 146.875 134.953 146.883 134.766 146.883C132.25 146.883 130.148 145.961 128.461 144.117C126.836 142.352 126.023 139.141 126.023 134.484C126.023 133.922 126.039 133.336 126.07 132.727ZM151.031 114.281L156.352 113.93V121.688L160.828 121.57L160.898 126L156.352 126.211V136.875C156.352 139.359 157.406 140.602 159.516 140.602C159.953 140.602 160.43 140.547 160.945 140.438L160.734 145.594C159.984 145.688 159.273 145.734 158.602 145.734C153.664 145.734 151.148 143.188 151.055 138.094V126.633L147.211 126.867L147.117 121.641L151.055 121.688L151.031 114.281ZM171.938 121.078C177.078 121.359 179.648 123.945 179.648 128.836V145.477L174.188 145.57L174 143.344C172.875 144.625 171.383 145.266 169.523 145.266C168.727 145.266 167.867 145.141 166.945 144.891C164.18 144.203 162.797 142.062 162.797 138.469C162.797 138.031 162.82 137.562 162.867 137.062C163.18 133.359 165.812 131.508 170.766 131.508C171.719 131.508 172.766 131.578 173.906 131.719V129C173.906 126.797 173.211 125.695 171.82 125.695H171.727C171.617 125.68 171.516 125.672 171.422 125.672C169.906 125.672 169.148 126.906 169.148 129.375V129.727L163.57 129.258C163.57 123.805 166.195 121.078 171.445 121.078H171.938ZM173.906 139.594V135.469C173.234 135.328 172.625 135.258 172.078 135.258C170.656 135.258 169.688 135.734 169.172 136.688C168.859 137.266 168.703 137.805 168.703 138.305C168.703 138.93 168.953 139.484 169.453 139.969C169.844 140.344 170.352 140.531 170.977 140.531C171.773 140.531 172.75 140.219 173.906 139.594ZM187.758 129.023L187.992 146.016L182.25 146.062C182.25 138.875 182.008 130.805 181.523 121.852L185.836 121.383L186.07 125.203C186.727 123.328 188.258 122.258 190.664 121.992C191.023 121.961 191.367 121.945 191.695 121.945C193.586 121.945 195.023 122.562 196.008 123.797C197.148 125.266 197.727 127.602 197.742 130.805L192.539 131.32C192.555 131.055 192.562 130.797 192.562 130.547C192.562 128.047 191.914 126.797 190.617 126.797H190.523C189.023 126.875 188.102 127.617 187.758 129.023ZM203.25 114.281L208.57 113.93V121.688L213.047 121.57L213.117 126L208.57 126.211V136.875C208.57 139.359 209.625 140.602 211.734 140.602C212.172 140.602 212.648 140.547 213.164 140.438L212.953 145.594C212.203 145.688 211.492 145.734 210.82 145.734C205.883 145.734 203.367 143.188 203.273 138.094V126.633L199.43 126.867L199.336 121.641L203.273 121.688L203.25 114.281Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1160_43934",
    x: 2,
    y: 3,
    width: 339,
    height: 212,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.447059 0 0 0 0 0.054902 0 0 0 0 0.286275 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1160_43934",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_1160_43934",
    x: 2,
    y: 142,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43934",
    result: "effect2_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43934",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_1160_43934",
    x: 33,
    y: 156,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43934",
    result: "effect2_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43934",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dd_1160_43934",
    x: 73,
    y: 171,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43934",
    result: "effect2_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43934",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dd_1160_43934",
    x: 115,
    y: 182,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43934",
    result: "effect2_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43934",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_dd_1160_43934",
    x: 157,
    y: 189,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43934",
    result: "effect2_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43934",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_dd_1160_43934",
    x: 200,
    y: 182,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43934",
    result: "effect2_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43934",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_dd_1160_43934",
    x: 241,
    y: 171,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43934",
    result: "effect2_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43934",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_dd_1160_43934",
    x: 281,
    y: 156,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43934",
    result: "effect2_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43934",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_dd_1160_43934",
    x: 316,
    y: 142,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43934",
    result: "effect2_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43934",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_dd_1160_43934",
    x: 319,
    y: 111,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43934",
    result: "effect2_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43934",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_dd_1160_43934",
    x: 319,
    y: 77,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43934",
    result: "effect2_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43934",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_dd_1160_43934",
    x: 0,
    y: 111,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43934",
    result: "effect2_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43934",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_dd_1160_43934",
    x: 0,
    y: 77,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43934",
    result: "effect2_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43934",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_dd_1160_43934",
    x: 2,
    y: 46,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43934",
    result: "effect2_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43934",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_dd_1160_43934",
    x: 33,
    y: 32,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43934",
    result: "effect2_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43934",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_dd_1160_43934",
    x: 73,
    y: 17,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43934",
    result: "effect2_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43934",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_dd_1160_43934",
    x: 115,
    y: 6,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43934",
    result: "effect2_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43934",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_dd_1160_43934",
    x: 157,
    y: 0,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43934",
    result: "effect2_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43934",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_dd_1160_43934",
    x: 200,
    y: 6,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43934",
    result: "effect2_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43934",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_dd_1160_43934",
    x: 241,
    y: 17,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43934",
    result: "effect2_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43934",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_dd_1160_43934",
    x: 281,
    y: 32,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43934",
    result: "effect2_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43934",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_dd_1160_43934",
    x: 316,
    y: 46,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43934",
    result: "effect2_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43934",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_d_1160_43934",
    x: 77.8203,
    y: 58.4922,
    width: 182,
    height: 103.391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.0941176 0 0 0 0 0.443137 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1160_43934",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1160_43934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(170 105) rotate(90) scale(63.5 265.805)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE6BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE6BFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1160_43934",
    x1: 169.5,
    y1: 3,
    x2: 169.5,
    y2: 207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F54C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C52C88"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1160_43934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.5833 150.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1160_43934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.5833 164.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1160_43934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.5833 179.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1160_43934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124.583 190.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1160_43934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(166.583 197.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1160_43934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.583 190.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1160_43934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(250.583 179.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1160_43934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(290.583 164.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1160_43934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(325.583 150.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1160_43934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(328.583 119.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1160_43934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(328.583 85.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_1160_43934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.58333 119.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1160_43934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.58333 85.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_1160_43934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.5833 54.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_1160_43934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.5833 40.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_1160_43934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.5833 25.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_1160_43934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124.583 14.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_1160_43934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(166.583 8.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_1160_43934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.583 14.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_1160_43934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(250.583 25.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_1160_43934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(290.583 40.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_1160_43934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(325.583 54.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoiningTop);
export default __webpack_public_path__ + "static/media/joining-top.a0520654.svg";
export { ForwardRef as ReactComponent };